import Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VeeValidate, { Validator } from 'vee-validate';
import fr from './locale/_fr.js';
let controller = new AbortController();


Vue.use(VueAxios, axios)
Vue.use(VeeValidate);
Validator.localize('fr', fr);

Vue.filter("formatNumber", function (value) {
    var formatter = new Intl.NumberFormat('fr-FR', { maximumSignificantDigits: 2 });
    return formatter.format(value);
});

new Vue({
    el: "#simulation",
    delimiters: ['${', '}'],
    data: function () {
        return {
            type_structure: {},
            ca: "",
            price: null,
            pricing: window.pricing,
            pricingOptions: []
        }
    },
    methods: {
        async getPricing() {
            if (controller) controller.abort();
            controller = new AbortController();
            const signal = controller.signal;

            this.price = null;
            if(this.type_structure.id && this.ca) {
                try {
                    const {data} = await this.$http.post(
                        '/gateway/get-price',
                        {structure: this.type_structure.id, ca: this.ca},
                        {signal: signal}
                    );
                    if(data.status == "success"){
                        this.price = data.price.price;
                    }
                }catch (e) {
                    this.price = null;
                }
            }
        },
        goToJoin: function (event) {
            var url = new URL(event.target.href);
            if(this.type_structure.id){
                url.searchParams.append('type', JSON.stringify(this.type_structure));
            }
            if(this.ca){
                url.searchParams.append('ca', this.ca);
            }
            window.location.href = url.href;
        }
    }
});
